// This file is only a template for BaseAppComponents.  Copy and paste this to your application .tsx file and start off from there
// Rename all things with App_Name.
// Naming convention for BaseAppComponents is "[App Name]App.tsx" i.e. UsersApp.tsx, EntitlementApp.tsx

import React from 'react';
import UserProfileStore from './../stores/UserProfileStore';
import UserProfileActions from './../actions/UserProfileActions';
import UserProfileConstants from './../constants/UserProfileConstants';
import ChangeUserPassword from './../components/ChangeUserPassword';
import SystemActions from './../../../actions/SystemActions';
import SystemStore from './../../../stores/SystemStore';
import UrlUtilities from '../../../common/UrlUtilities';
import BaseAppComponent from './../../../components/class/BaseAppComponent';
import ReactLoader from './../../../components/core/ReactLoader';
import If from './../../../components/controls/If';
import FormField from './../../../components/controls/FormField';
import ModalPopUp from './../../../components/controls/ModalPopUp';
import AuthenticationModeEnum from "./../constants/AuthenticationModeEnum";
import ExternalProviderEnum from "./../constants/ExternalProviderEnum";
declare var InovxLoader: any;

interface UserProfileProps {
    onOK: () => void;
}

interface UserProfileState {
    editProfile: IUserProfile;
    isActionInProgress: boolean;
    displayPasswordChange: boolean;
    hasChanges: boolean;
    validation: IValidationDictionaryObject;
    localOnlyLogin: boolean;
    externalOnlyLogin: boolean;
    externalProviderName: string;
}

var _displayPasswordChange: boolean;

function getActionInProgress() {
    return SystemStore.isActionInProgress(UserProfileConstants.PROFILE_UPDATE) || SystemStore.isActionInProgress(UserProfileConstants.PROFILE_GET_PASSWORD_SETTINGS);
}

function getProfileState(): UserProfileState {
    var profile: IUserProfile = UserProfileStore.getEditProfile();
    return {
        editProfile: profile,
        localOnlyLogin: profile.AuthenticationMode == AuthenticationModeEnum.LocalOnly ? true : false,
        externalOnlyLogin: profile.AuthenticationMode == AuthenticationModeEnum.ExternalOnly ? true : false,
        externalProviderName: profile.ExternalProviderName,
        displayPasswordChange: _displayPasswordChange,
        isActionInProgress: getActionInProgress(),
        hasChanges: UserProfileStore.getHasChanges(),
        validation: UserProfileStore.getValidation(UserProfileConstants.PROFILE_MAIN_PAGE)
    };
}

class UserProfileAppReadOnly extends BaseAppComponent<UserProfileProps, UserProfileState> {
    constructor(props: UserProfileProps, context: any) {
        super('UserProfile', props, context);

        this._initialize = this._initialize.bind(this);      

        _displayPasswordChange = false;
        this.state = getProfileState();
    }
    
    protected _initialize() {
        UserProfileActions.getProfile(
            () => this._appLoaded = true,
            (error: any) => this._handlePermissionError(error),
            true
        );
    }

    private _onChange = () => {
        this.setState(getProfileState());
    }

    private _onSystemChange = () => {
        this.setState({
            isActionInProgress: getActionInProgress()
        } as any);
    }

    private _onInputChanged = (event: any) => {
        UserProfileActions.editCurrentObject(UserProfileConstants.PROFILE_MAIN_PAGE, event.target.name, event.target.value);
    }

    private _updateProfile = () => {
        UserProfileActions.updateProfile(this.state.editProfile,
            () => {
            },
            () => {
            });
    }

    private _cancelChanges = () => {
        UserProfileActions.cancelChanges();
    }

    private _onUpdatePassword = () => {
        this._onChangePassword();
    }

    private _closeChangePassword = () => {
        _displayPasswordChange = false;
        this.setState({
            displayPasswordChange: _displayPasswordChange
        } as any);
    }

    private _onChangePassword = () => {
        _displayPasswordChange = true;
        this.setState({
            displayPasswordChange: _displayPasswordChange
        } as any);
    }

    UNSAFE_componentWillMount() {

        this.componentWillMountBase();
    }

    componentDidMount() {
        UserProfileStore.addChangeListener(this._onChange);
        SystemStore.addChangeListener(this._onSystemChange);
    }

    componentWillUnmount() {
        UserProfileStore.removeChangeListener(this._onChange);
        SystemStore.removeChangeListener(this._onSystemChange);
    }


    public render() {
        var inputObj = {
            className: 'form-control',
            type: 'text'
        }

        var profile = this.state.editProfile;

        var iconHeaderProps: any = {
            iconUrl: `${UrlUtilities.getBaseApplicationUrl()}/images/Users.png`,
            iconAtt: { alt: "profile" },
            title: InovxLoader.t('UserProfile:header.profile')
        };
        var usernameLabel = InovxLoader.t("UserProfile:common.username");
        if (this.state.externalProviderName == ExternalProviderEnum.ADFS) {
            usernameLabel = InovxLoader.t("UserProfile:common.adfsUsername");
        } else if (this.state.externalProviderName == ExternalProviderEnum.AzureAD) {
            usernameLabel = InovxLoader.t("UserProfile:common.azureUsername");
        }

        return (
            <ReactLoader appReady={this.isAppLoaded()} errorStatus={this._errorStatus}>

                <If condition={this.state.isActionInProgress} class={'temp-modal-loader'}>
                    <div className="action-in-progress-loader-lrg"></div>
                </If>

                <div className="panel panel-primary user-profile-app-content">
                    <div className="panel-heading">{InovxLoader.t("UserProfile:header.account")}</div>
                    <div className="panel-body fc-margin">
                        <div className="row profile-form-row">
                            <div className="col-sm-5">
                                <div className="form-field">
                                    <label className="profile-form-field" htmlFor="Email">{InovxLoader.t("UserProfile:common.email")}</label>
                                </div>
                                <div className="fr-margin">
                                    <span className="user-field-viewonly">{profile.Email}</span>
                                </div>
                            </div>
                            <div className="col-sm-7">
                                {!this.state.localOnlyLogin &&
                                    <div>
                                        <div className="form-field">
                                            <label className="profile-form-field" htmlFor="ExternalAccountUserName">{usernameLabel}</label>
                                        </div>
                                        <div className="fr-margin">
                                            <span className="user-field-viewonly">{profile.ExternalAccountUserName}</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="row profile-form-row">
                            <div className="col-sm-5">
                                <div className="form-field">
                                    <label className="profile-form-field" htmlFor="FirstName">{InovxLoader.t("UserProfile:common.firstname")}</label>
                                </div>
                                <div className="fr-margin">
                                    <span className="user-field-viewonly">{profile.FirstName}</span>
                                </div>
                            </div>
                            <div className="col-sm-7">
                                <div className="form-field">
                                    <label className="profile-form-field" htmlFor="LastName">{InovxLoader.t("UserProfile:common.lastname")}</label>
                                </div>
                                <div className="fr-margin">
                                    <span className="user-field-viewonly">{profile.LastName}</span>
                                </div>
                            </div>
                        </div>
                        {!this.state.externalOnlyLogin &&
                            <div className="profile-form-row">
                                <a className="btn btn-info" onClick={this._onUpdatePassword}>{InovxLoader.t("UserProfile:form.resetPassword")}</a>
                                <If condition={profile.PasswordExpired}>
                                    <h5 className="password-expired-warning">{InovxLoader.t("UserProfile:form.passwordExpired")}</h5>
                                </If>
                            </div>
                        }
                        <div className="btn-bar-b-sm">
                            <button type="button" className="btn btn-primary" onClick={this.props.onOK}>{InovxLoader.t("UserProfile:form.ok")}</button>
                        </div>
                    </div>
                </div>
                <ModalPopUp isOpen={this.state.displayPasswordChange} class={['faded']} >
                    <ChangeUserPassword onPasswordChanged={this._closeChangePassword} onCancel={this._closeChangePassword} />
                </ModalPopUp>
            </ReactLoader>
        );
    }
}

export default UserProfileAppReadOnly;